import React, { useRef, useEffect } from "react"
import createDOMPurify from "dompurify"
import { decodeHtmlCharacters } from "@/utils/helper"

const DOMPurify =
  typeof window !== "undefined" ? createDOMPurify(window) : null

const AdditionalInfo = ({ data = [], productAccordionText }) => {
  const addInfoRef = useRef(null)

  const addMailAnalytics = (text, link) => {
    const eventInfo = {
      clickInternalLinks: "true",
      eventAction: "pdp:additional information:email",
      eventName: "pdp:additional information:email",
      eventType: "navigation",
      internalLinkName: text,
      internalLinkPosition: "pdp",
      internalLinkType: "pdp:contact customer care",
      internalLinkZoneName: "pdp:additional information",
      internalLinkURL: link,
    }
    const page = window.adobeDataLayer.getState("page")
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      productInfo: page.productInfo ?? null,
    })
  }

  useEffect(() => {
    // to add analytics for cutsomer care email
    const elem = addInfoRef.current.querySelectorAll('a[href^="mailto"]')
    if (elem[0]) {
      elem[0].addEventListener("click", () =>
        addMailAnalytics(elem[0].innerText, elem[0].getAttribute("href"))
      )
    }
  }, [])

  return (
    <ul ref={addInfoRef} className="pdp-additional-info">
      {data.map((item, i) =>
        item.data ? (
          <li key={i}>
            <h5 className="pdp-spec-detail__title">{item.title}</h5>
            {item.title === productAccordionText.additionalInfo.contact ||
            item.title === productAccordionText.additionalInfo.disclaimer ||
            item.title === productAccordionText.additionalInfo.spareParts ? (
              <p
                className="pdp-features-technologies__list-item"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify
                    ? DOMPurify.sanitize(
                        decodeHtmlCharacters(item.data)
                      )
                    : decodeHtmlCharacters(item.data),
                }}
              />
            ) : (
              <p className="pdp-features-technologies__list-item">
                {item.data}
              </p>
            )}
          </li>
        ) : null
      )}
    </ul>
  )
}

export default AdditionalInfo
